import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import { useClipboard } from '@vueuse/core';
import MarkdownIt from 'markdown-it';
import 'highlight.js/styles/vs2015.min.css';
import hljs from 'highlight.js';
import { computed, onMounted, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
// 定义组件属性
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    content: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const message = useMessage(); // 消息弹窗
    const {
      copy
    } = useClipboard(); // 初始化 copy 到粘贴板
    const contentRef = ref();
    const md = new MarkdownIt({
      highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            const copyHtml = `<div id="copy" data-copy='${str}' style="position: absolute; right: 10px; top: 5px; color: #fff;cursor: pointer;">复制</div>`;
            return `<pre style="position: relative;">${copyHtml}<code class="hljs">${hljs.highlight(lang, str, true).value}</code></pre>`;
          } catch (__) {}
        }
        return ``;
      }
    });
    /** 渲染 markdown */
    const renderedMarkdown = computed(() => {
      return md.render(props.content);
    });
    /** 初始化 **/
    onMounted(async () => {
      // 添加 copy 监听
      contentRef.value.addEventListener('click', e => {
        if (e.target.id === 'copy') {
          copy(e.target?.dataset?.copy);
          message.success('复制成功!');
        }
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "contentRef",
        ref: contentRef,
        class: "markdown-view",
        innerHTML: renderedMarkdown.value
      }, null, 8, _hoisted_1);
    };
  }
});